exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-drag-select{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-drag-select:hover{cursor:pointer}.vue-drag-select-box{position:absolute;z-index:99}\n", ""]);

// exports
